import React, { useState, useRef } from "react";
import './message.less';
const NOOP = () => { };

export function Message(props) {
  const { visible, role = 'customer', title, orderNo, list = [], onClick = NOOP, send = NOOP, record } = props;
  const [sendMsg, setSendMsg] = useState('');
  const textarea = useRef();
  return visible ? <div className="message_container">
    <div className="title">
      <span className="text">{title}</span>
      <span className="close" onClick={onClick}></span>
    </div>
    <div className="message_scroll_content">
      {
        list.map((item, index) => <React.Fragment key={index}>
          {
            item.role === (role === 'customer' ? 1 : 0) ? <div className='left'>
              <div className='avator'>{item.avator}</div>
              <div className="rectangle">
                <div className='time'>{item.createTime}</div>
                <div className='text'>{item.msgInfo}</div>
              </div>
            </div> : null
          }
          {
            item.role === (role === 'customer' ? 0 : 1) ? <div className='right'>
              <div className="rectangle">
                <div className='time'>{item.createTime}</div>
                <div className='text'>{item.msgInfo}</div>
              </div>
              <div className='avator'>{item.avator}</div>
            </div> : null
          }
        </React.Fragment>)
      }
    </div>
    <div className='bottom'>
      <div className="order">
        <span className="text">订单号：{orderNo}</span>
        {/* <span className="order_detail" onClick={() => { onHandlerDetail(record) }}>订单详情</span> */}
      </div>
      <div className="send_line">
        <textarea className="input" ref={textarea} onChange={(e) => setSendMsg(e.target.value)} />
        <button className="send" onClick={() => {
          textarea.current.value = '';
          setSendMsg('');
          send(sendMsg, record);
        }}>发送</button>
      </div>
    </div>
  </div> : null;
}